import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import th from './th.json';
import en from './en.json';

const LANGUAGE_STORAGE_KEY = 'findoryhub_language';

function getStoredLanguage(): string {
  try {
    return localStorage.getItem(LANGUAGE_STORAGE_KEY) ?? 'th';
  } catch {
    return 'th';
  }
}

i18n.use(initReactI18next).init({
  resources: {
    th: { translation: th },
    en: { translation: en },
  },
  lng: getStoredLanguage(),
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

i18n.on('languageChanged', (lng: string) => {
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, lng);
  } catch {
    // localStorage unavailable, ignore
  }
  document.documentElement.lang = lng;
});

export { LANGUAGE_STORAGE_KEY };
export default i18n;
